var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3GarageClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 27.08L21 14.28 0 29.11V59h76V27.08H39.6zM38 55H24v-9h-6v9H4V31.22l17-12 17 11.69V55zm34 0H42v-4h6v1h1.5v1.48a1.5 1.5 0 103 0V52h9v1.48a1.5 1.5 0 103 0V52H66v-1h6v4zm0-7H42v-3h30v3zm0-7H42v-3h30v3zm0-7H42v-3h30v3zm-40 6h-6v-6h6v6zm-22-6h6v6h-6v-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Garage_close.ff0db8d5.svg";
export { SvgE3GarageClose as ReactComponent };